import React, { Component } from "react";
import { Route, Link } from "react-router-dom";

import Home from "./routes/home.js";

const routes = [
	{
		path: "/",
		component: Home,
		text: "Start"
	}
];

const RouteList = class extends Component {
	/**
	 *
	 *
	 * @returns {JSX.Element}
	 * component
	 */
	render() {
		return routes.map((route, i) => {
			if (route.path === "/") {
				return (<Route key={i} exact path={route.path} component={route.component} />);
			}

			return (<Route key={i} path={route.path} component={route.component} />);
		});
	}
};

const RouteLinks = class extends Component {
	/**
	 *
	 *
	 * @returns {JSX.Element}
	 * component
	 */
	render() {
		return routes.map((route, i) => (<Link key={i} to={route.path}>{route.text}</Link>));
	}
};

export { RouteList, RouteLinks };

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js